var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('div',_vm._l((_vm.numberOfRepeatingRoles),function(index){return _c('formio-form',{key:index,attrs:{"export-metadata":_vm.buildRepeatingRoleExportMetadata(_vm.exportMetadata.ComponentTree.components[0].formJson, index - 1)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }